import { useCallback, useEffect, useState } from 'react';

interface BrandingData {
  logo?: string;
}

export type { BrandingData };

export function useLogoUpload(brandingData: BrandingData) {
  const [isCropImageOpen, setIsCropImageOpen] = useState<boolean>(false);
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [logoPreview, setLogoPreview] = useState<string | null>(null);
  const [prevLogoFile, setPrevLogoFile] = useState<File | null>(null);
  const [prevLogoPreview, setPrevLogoPreview] = useState<string | null>(null);
  const [originalLogoFile, setOriginalLogoFile] = useState<File | null>(null);
  const [originalLogoPreview, setOriginalLogoPreview] = useState<string | null>(
    null,
  );
  const [currentFileType, setCurrentFileType] = useState<string>('');

  useEffect(() => {
    if (brandingData) {
      setLogoPreview(brandingData.logo || null);
      setLogoFile(null);
    }
  }, [brandingData]);

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles[0]) {
        setPrevLogoFile(logoFile);
        setPrevLogoPreview(logoPreview);
        setOriginalLogoFile(acceptedFiles[0]);
        setOriginalLogoPreview(URL.createObjectURL(acceptedFiles[0]));
        setLogoFile(acceptedFiles[0]);
        setLogoPreview(URL.createObjectURL(acceptedFiles[0]));
        setCurrentFileType(acceptedFiles[0].type);
        setIsCropImageOpen(true);
      }
    },
    [logoFile, logoPreview],
  );

  const handleCropSave = (blob: Blob) => {
    const ext = currentFileType.split('/')[1] || 'png';
    const file = new File([blob], `logo.${ext}`, { type: blob.type });
    setLogoFile(file);
    setLogoPreview(URL.createObjectURL(file));
    setIsCropImageOpen(false);
  };

  return {
    isCropImageOpen,
    setIsCropImageOpen,
    logoFile,
    setLogoFile,
    logoPreview,
    setLogoPreview,
    prevLogoFile,
    prevLogoPreview,
    originalLogoFile,
    originalLogoPreview,
    currentFileType,
    setCurrentFileType,
    onDrop,
    handleCropSave,
  };
}
